import type {
  GetDocumentsRenderedRequestType,
  GetDocumentsRenderedResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

/**
 * Method to get rendered document url
 *
 * @param params - Parameters for fetching rendered document url
 */
export const getDocumentRendered = async (
  params: GetDocumentsRenderedRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/rendered`;
  const { headers } = await apiAuthClient.get<GetDocumentsRenderedResponseType>(
    url,
    {
      headers: {
        accept: '/',
      },
      ...params,
    },
  );

  return headers['x-redirect-to'];
};
